export default __webpack_public_path__ + "static/media/17_2_0.81978235.png";